export interface CryptoService {
  encrypt(message: string): Promise<string>;
}

class CryptoProvider {
  service: CryptoService | undefined;
}

export default new CryptoProvider();
